var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / GB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-GB",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#0A17A7",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2824692,-1.91644623 L30.7736503,0.29432063 L21.3253497,6.66655377 L28,6.66666667 L28,13.3333333 L21.3253497,13.3325538 L30.7736503,19.7056794 L29.2824692,21.9164462 L17.3323497,13.8555538 L17.3333333,21.3333333 L10.6666667,21.3333333 L10.6663497,13.8555538 L-1.2824692,21.9164462 L-2.77365027,19.7056794 L6.67434973,13.3325538 L4.4408921e-16,13.3333333 L4.4408921e-16,6.66666667 L6.67434973,6.66655377 L-2.77365027,0.29432063 L-1.2824692,-1.91644623 L10.6663497,6.14355377 L10.6666667,-1.33333333 L17.3333333,-1.33333333 L17.3323497,6.14355377 L29.2824692,-1.91644623 Z",
    id: "Rectangle-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.6679688,
    y1: 6.33219401,
    x2: 31.3333333,
    y2: -2,
    id: "Line",
    stroke: "#DB1F35",
    strokeWidth: 0.666666667,
    strokeLinecap: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.0127767,
    y1: 21.3503418,
    x2: 31.3666178,
    y2: 13.6975098,
    id: "Line-Copy-2",
    stroke: "#DB1F35",
    strokeWidth: 0.666666667,
    strokeLinecap: "round",
    mask: "url(#mask-2)",
    transform: "translate(25.689697, 17.523926) scale(1, -1) translate(-25.689697, -17.523926) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.00553385,
    y1: 6.31046549,
    x2: -3.83748372,
    y2: -1.67097982,
    id: "Line-Copy",
    stroke: "#DB1F35",
    strokeWidth: 0.666666667,
    strokeLinecap: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.29003906,
    y1: 22.3104655,
    x2: -3.83748372,
    y2: 13.6048991,
    id: "Line-Copy-3",
    stroke: "#DB1F35",
    strokeWidth: 0.666666667,
    strokeLinecap: "round",
    mask: "url(#mask-2)",
    transform: "translate(2.726278, 17.957682) scale(1, -1) translate(-2.726278, -17.957682) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2-Copy-3",
    fill: "#E6273E",
    mask: "url(#mask-2)",
    points: "0 12 12 12 12 20 16 20 16 12 28 12 28 8 16 8 16 0 12 0 12 8 0 8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/EN.cb709ecc3813e49ce8c98c25619f019f.svg";
export { ForwardRef as ReactComponent };